import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-bold mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors whitespace-nowrap">
                天天漫画网
              </Link>
            </h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              天天漫画网主打下拉式完整版免费阅读，无删减韩国漫画资源充足，下拉观看流畅便捷，让您每天都能免费解锁完整版韩国漫画的新鲜剧情。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50/80 mb-4 uppercase tracking-wider">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50/80 mb-4 uppercase tracking-wider">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50/80 mb-4 uppercase tracking-wider">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 天天漫画网 - 下拉式完整版免费阅读，无删减韩国漫画资源充足
          </p>
          <p className="text-xs text-background-50/40">
            专注提供高品质漫画在线阅读体验
          </p>
        </div>
      </div>
    </footer>
  );
}